import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { APIKeysService } from './api-keys.service';
import { APIKey, APIKeyType } from '../models/api-key';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { APIKeyForm, APIKeyFormService } from './api-key-form.service';
import { ApiKeyTypesService } from './api-key-types.service';
import { ReactiveEntityCreatePageComponent } from '../util/reactive-entity-create-page.base';
import { MessageEventService } from '../util/message-event.service';

@Component({
  selector: 'app-api-key-create',
  templateUrl: './api-key-create.component.html',
  styleUrls: ['./api-key-create.component.scss'],
  providers: [APIKeyFormService],
})
export class ApiKeyCreateComponent
  extends ReactiveEntityCreatePageComponent<APIKey, APIKeyForm>
  implements OnInit, OnDestroy
{
  minDate = new Date();

  types$: Observable<APIKeyType[]>;

  constructor(
    apiKeysService: APIKeysService,
    private apiKeyTypesService: ApiKeyTypesService,
    messageService: MessageEventService,
    titleService: Title,
    router: Router,
    formService: APIKeyFormService
  ) {
    super(apiKeysService, messageService, router, titleService, formService);
  }

  protected getEntityCreatedMessage(createdAPIKey: APIKey): string {
    return `API Key '${createdAPIKey.name}' created`;
  }

  protected getPostCreateRoute(createdAPIKey: APIKey): string[] {
    return ['/organization/apikeys'];
  }

  protected cancelCreate() {
    this.router.navigate(['/organization/apikeys']);
  }

  protected getTitle(): string {
    return 'Generate API Key';
  }

  ngOnInit() {
    super.ngOnInit();
    this.types$ = this.apiKeyTypesService.getAll();
  }
}
